// extracted by mini-css-extract-plugin
export default {"Img":"ExaminationRoomQueue_Img__ucs0D"};